import AlertDialog from "@global/helpers/alertDialog";

var $mainContent = $("#main-content");

function unlockScroll() {
	$mainContent.removeClass("lock-scroll");
}

function lockScroll() {
	$mainContent.addClass("lock-scroll");
}

function subscribeEDM() {
	$.ajax({
		type: "POST",
		url: "/api/v1/Subscribe/Apply",
		dataType: "json",
		data: { Email: $("#input-newsletter").val() },
		xhrFields: {
			withCredentials: false,
		},
		error: function () {
			console.log("error");
		},
		success: function (res) {
			AlertDialog.alert(res.Message);
		},
	});
}

function goToSearch(inputVal) {
	if (inputVal === "") {
		AlertDialog.alert("請輸入關鍵字");
	} else {
		window.location.href = "/search?Keyword=" + inputVal;
	}
}

$(document).on("click", ".open-sidebar", function (e) {
	e.preventDefault();
	$($(this).data("sidebar")).addClass("active");
	$(".sidebar-mask").fadeIn();
	lockScroll();
});

$(document).on("click", ".close-sidebar", function (e) {
	e.preventDefault();
	var $el = $(this),
		target = $el.data("sidebar");
	$(target).removeClass("active");
	$(".sidebar-mask").fadeOut();
	unlockScroll();
});

$(document).on("click", ".btn-pc-search", function (e) {
	e.preventDefault();

	$(this).fadeOut("fast", function () {
		$(".pc-input-search").addClass("active");
		$(".pc-input-search .all-input-search").focus();
	});
});

$(document).on("click", ".close-pc-search", function (e) {
	e.preventDefault();
	$(".pc-input-search").removeClass("active");
	$(".btn-pc-search").fadeIn("fast");
});

$(document).on("click", ".btn-search-item", function (e) {
	e.preventDefault();
	goToSearch($(this).parents(".search-control-block").find(".all-input-search").val());
});

$(document).on("keypress", ".pc-input-search .all-input-search", function (e) {
	if (e.key === "Enter") {
		goToSearch($(this).parents(".search-control-block").find(".all-input-search").val());
	}
});

$(document).on("click", ".btn-search", function (e) {
	e.preventDefault();
	$("#lb-search").fadeIn();
	$("#lb-search .all-input-search").focus();
	lockScroll();
});

$(document).on("click", "#close-search", function (e) {
	e.preventDefault();
	$("#lb-search").fadeOut();
	unlockScroll();
});

$(document).on("keypress", "#input-newsletter", function (e) {
	if (e.key === "Enter") {
		e.preventDefault();
		subscribeEDM();
	}
});

$(document).on("click", "#btn-get-newsletter", function (e) {
	e.preventDefault();
	subscribeEDM();
});
